"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LoginFormBankId = require("./LoginFormBankId.vue");

var _LoginFormBankId2 = _interopRequireDefault(_LoginFormBankId);

var _LoginFormEmail = require("./LoginFormEmail.vue");

var _LoginFormEmail2 = _interopRequireDefault(_LoginFormEmail);

var _ForgotPassword = require("./ForgotPassword.vue");

var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);

var _ContactUs = require("./ContactUs");

var _ContactUs2 = _interopRequireDefault(_ContactUs);

var _authenticate = require("../../mixins/authenticate");

var _authenticate2 = _interopRequireDefault(_authenticate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      selectedComponent: '',
      appLoginFormBankId: 'appLoginFormBankId',
      appLoginFormEmail: 'appLoginFormEmail'
    };
  },


  /**
   * Mixins
   */
  mixins: [_authenticate2.default],

  methods: {
    showForgotPassword: function showForgotPassword() {
      this.selectedComponent = "appForgotPassword";
    },
    goToEmailLogin: function goToEmailLogin() {
      this.selectedComponent = "appLoginFormEmail";
    }
  },

  components: {
    appLoginFormBankId: _LoginFormBankId2.default,
    appLoginFormEmail: _LoginFormEmail2.default,
    appForgotPassword: _ForgotPassword2.default,
    ContactUs: _ContactUs2.default
  },

  mounted: function mounted() {
    if (this.getSidFromUrl()) {
      this.selectedComponent = this.appLoginFormBankId;
    }

    if (window.globals.flashMessage) {
      Event.fire("flash", {
        message: window.globals.flashMessage,
        level: window.globals.flashStatus
      });
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/login/LoginForm.vue
// module id = 2ocs
// module chunks = 0 1